import React from "react";
import { MenuContextValue } from "types/menu";

export const Context = React.createContext<MenuContextValue | null>(null);

export default Context;
